import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var Bold = /*#__PURE__*/_styled("b", true ? {
  target: "e18mqg2l0"
} : {
  target: "e18mqg2l0",
  label: "Bold"
})(true ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : {
  name: "16ceglb",
  styles: "font-weight:600",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvUmljaFRleHQvUmljaFRleHQudmlld3MudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUU0QiIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL1JpY2hUZXh0L1JpY2hUZXh0LnZpZXdzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5leHBvcnQgY29uc3QgQm9sZCA9IHN0eWxlZC5iYFxuICBmb250LXdlaWdodDogNjAwO1xuYFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});